import { initialAction, initialState } from './initial';

type Reducer = (
  state: typeof initialState,
  action: typeof initialAction,
) => typeof initialState;

const reducer: Reducer = (state, action) => {
  const { type, payload } = action ?? {};

  switch (type) {
    case 'UPDATE_CATALOG_BRAND':
    case 'UPDATE_CATALOG_DESCRIPTION':
    case 'UPDATE_CATALOG_FILES':
    case 'UPDATE_CATALOG_SEO':
    case 'UPDATE_CATALOG_STEP': {
      return {
        ...state,
        ...payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer };
